const medicareAU = {
  green: '绿色',
  blue: '蓝色',
  yellow: '黄色',
};

export default medicareAU;
